import './scss/index.scss'
import { useMemo, useRef, Suspense, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { Loader, ScrollControls } from '@react-three/drei'
import EnvMap from './props/EnvMap.jsx'
import Ui from './ui/Ui'
import { ActsCurrentDebug } from './ActsDebug.jsx'
import { Perf } from 'r3f-perf'
import StabPerformance from './StabPerformance.jsx'
import UiPass from './ui/UiPass.jsx'
import { TouchScrollLimiter, DesktopScrollLimiter } from './utils/touchScrollMobileLimiter.jsx'
import LoaderScreen from './LoaderScreen.jsx'


function App() {
    const isMobile = useMemo(() => {
        if (typeof window === "undefined") return false
        return window.matchMedia("(pointer: coarse)").matches
    }, [])

    const [start, setStart] = useState(false);

    return (
        <>
            <Ui />
            <UiPass />
            <Canvas
                style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, overflow: 'hidden' }}
                shadows
                gl={{
                    powerPreference: 'high-performance',
                    antialias: false,
                    depth: true,
                }}
            >
                <StabPerformance />
                <Suspense fallback={null}>
                    <ScrollControls pages={isMobile ? 6 : 10} damping={isMobile ? 0.3 : 0.2}>
                        <EnvMap />
                        <TouchScrollLimiter enabled={isMobile} factor={0.8} smooth={0.12} />
                        <DesktopScrollLimiter />
                        <Experience />
                    </ScrollControls>
                </Suspense>
                {/* <Perf /> */}
            </Canvas>
            {/* <ActsCurrentDebug /> */}
            <LoaderScreen started={start} onStarted={() => setStart(true)} />
        </>
    )
}


const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)
